export const getUser = () => ({
  type: "@saga/GET_USER",
});
